import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Locale } from 'vant'

// 本地的文件夹
import zhLocale from './pack/zn'
import enLocale from './pack/en'
import trLocale from './pack/tr'
import taiLocale from './pack/tai'
import arLocale from './pack/ar'
import viLocale from './pack/vi'
import hanLocale from './pack/han'
import ptLocale from './pack/pt'
import esLocale from './pack/es'
import deLocale from './pack/de'
import frFRLocale from './pack/fr-FR'
import zhHantLocale from './pack/zhHant'
import riLocale from './pack/ri'
import itLocale from './pack/itIT'
import svLocale from './pack/sv'
import crLocale from './pack/cr'
import dgnLocale from './pack/dgn'
import rmLocale from './pack/rm'
import urLocale from './pack/ur'
import bnLocale from './pack/bn'
import hiLocale from './pack/hi'
import laLocale from './pack/la'
import msLocale from './pack/ms'
import elLocale from './pack/el'
import faLocale from './pack/fa'
import ruLocale from './pack/ru'

// vant中的文件夹  需要的语言和本地的语言保持一致
import zhCN from 'vant/lib/locale/lang/zh-CN'

import {
  TokenLangKey,
  getTokenbyName,
  setTokenbyName
} from "@/utils/cookies";

Vue.use(VueI18n)

const messages = {
  'en': {
    ...enLocale
  },
  'id':{
    ...dgnLocale
  },
  'cr' :{
    ...crLocale
  },
  'sv':{
      ...svLocale
  },
  'rm':{
    ...rmLocale
  },
  'zh-cn': {
    ...zhCN,
    ...zhLocale
  },
  'zh-TW': {
    ...zhHantLocale
  },
  'ur': {
    ...urLocale
  },
  'bn': {
    ...bnLocale
  },
  'hi': {
    ...hiLocale
  },
  'la': {
    ...laLocale
  },
  'th': {
    ...taiLocale
  },
  'ms': {
    ...msLocale
  },
  'el': {
    ...elLocale
  },
  'fa': {
    ...faLocale
  },
  'es':{
    ...esLocale
  },
  'tr': {
    ...trLocale
  },
  'pt':{
    ...ptLocale
  },
  'vi':{
    ...viLocale
  },
  'ru': {
    ...ruLocale
  },
  'de':{
    ...deLocale
  },
  'ko': {
    ...hanLocale
  },
  'ja':{
    ...riLocale
  },
  'it': {
    ...itLocale
  },
  'fr':{
    ...frFRLocale
  },
  'ar':{
    ...arLocale
  }
}
// localStorage获取当前语言类型(初次本地不存在'lang'字段存储，默认设置为'zh_CN')
let lang = getTokenbyName(TokenLangKey)// ''zh''
if (lang && lang.length > 0) {
  if (lang == "zh"  || lang == 'zh-CN') lang = "zh-cn";
} else {
  //lang = navigator.language || navigator.userLanguage
  //if (lang.indexOf('zh') > -1) {
  //  lang = 'zh-cn'
  //} else {
    lang = 'en'
  //}
  setTokenbyName(lang, TokenLangKey)
}
if(!messages[lang]){
  lang = 'en'
  setTokenbyName(lang, TokenLangKey)
}


// 初次加载的语言默认设置
Locale.use(lang, messages[lang])
export default new VueI18n({
  locale: lang, // set locale
  messages: messages // set locale messages
})
